import axios from 'axios'

import { getStudioAPIHost } from '@/utils/url'

const ENDPOINT = '/api/calibrations/setting'

// Custom error handler is intentionally a no-op so the global error handler is suppressed —
// the modal renders its own toast on failure.
const SUPPRESS_GLOBAL_ERROR = { customErrorHandler: () => {} }

export const getCalibrationSetting = async () => {
  const { data } = await axios.get(`${getStudioAPIHost()}${ENDPOINT}`, SUPPRESS_GLOBAL_ERROR)
  return data
}

export const putCalibrationSetting = async payload => {
  await axios.put(`${getStudioAPIHost()}${ENDPOINT}`, payload, SUPPRESS_GLOBAL_ERROR)
}
